import React from "react";

import { BaseButton } from "./styled";

const Button = ({
  children,
  leftIcon,
  rightIcon,
  size = "M",
  variant = "primary",
  colorScheme = "neutral",
  loading = false,
  ...rest
}) => {
  return (
    <BaseButton
      size={size}
      variant={variant}
      colorScheme={colorScheme}
      {...rest}
    >
      {leftIcon && leftIcon}
      {children}
      {rightIcon && rightIcon}
    </BaseButton>
  );
};

export default Button;
